module.exports = __webpack_public_path__ + "static/media/DebadityaB.jpg:Zone.a0f791c7.Identifier";